import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import { getFactoryNameList } from "app/services/apis/ListApi/factoryNameList";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Preview.css";
import convDate from "./date";
const PreviewModal = ({ open, setOpen, rowData }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [factoryData, setFactoryData] = useState(null);
  useEffect(() => {
    (async () => {
      const data = await getFactoryNameList(rowData?.factory_master_id);
      setFactoryData(data);
    })()
  }, []);
  const handleClose = () => {
    setOpen(false);
  };
  console.log(rowData)

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
      <DialogTitle>View Orders Details</DialogTitle>
      <DialogContent dividers>
        <div
          className="container"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 0,
            marginLeft: "11px",
          }}
        >
          <section>
            <table className="table-style">
              <thead>
                <tr>
                  <th
                    className="th-style"
                    style={{
                      padding: "0.8%",
                      fontSize: "16px",
                      fontFamily: "'Times New Roman', Times, serif",
                      borderLeft: "none",
                      borderTop: "none",
                    }}
                  >
                    Order No :-
                    <br />
                    <span style={{ color: "#000000", fontSize: "14px" }}>
                      {rowData?.order_no}
                    </span>
                  </th>
                  <th
                    className="th-style"
                    style={{
                      padding: "0.8%",
                      fontSize: "16px",
                      fontFamily: "'Times New Roman', Times, serif",
                      borderTop: "none",
                    }}
                  >
                    Client Name :-
                    <br />
                    <span style={{ color: "#000000", fontSize: "14px" }}>
                      {rowData?.order_client_name}
                    </span>
                  </th>
                  <th
                    className="th-style"
                    style={{
                      padding: "0.8%",
                      fontSize: "16px",
                      fontFamily: "'Times New Roman', Times, serif",
                      borderTop: "none",
                    }}
                  >
                    Gender :-
                    <br />
                    <span style={{ color: "#000000", fontSize: "14px" }}>
                      {rowData?.order_gender}
                    </span>
                  </th>
                  <th
                    className="th-style"
                    style={{
                      padding: "0.8%",
                      fontSize: "16px",
                      fontFamily: "'Times New Roman', Times, serif",
                      borderTop: "none",
                    }}
                  >
                    Order Date :-
                    <br />
                    <span style={{ color: "#000000", fontSize: "14px" }}>
                      {convDate(rowData?.item_order_date)}
                    </span>
                  </th>
                  <th
                    className="th-style"
                    style={{
                      padding: "0.8%",
                      fontSize: "16px",
                      fontFamily: "'Times New Roman', Times, serif",
                      borderTop: "none",
                      borderRight: "none",
                    }}
                  >
                    Est Delivery Date :
                    <br />
                    <span style={{ color: "#000000", fontSize: "14px" }}>
                      {convDate(rowData?.order_item_est_delivery_date)}
                    </span>
                  </th>
                  {/* <th
                    className="th-style"
                    style={{
                      padding: "0.8%",
                      fontSize: "16px",
                      fontFamily: "'Times New Roman', Times, serif",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                  >
                    Reference No :
                    <br />
                    <span style={{ color: "#000000", fontSize: "14px" }}>
                      {rowData?.reference_no ?? "-"}

                    </span>
                  </th> */}
                </tr>
              </thead>
            </table>
          </section>
          <section>
            <div
              style={{
                // borderTop: "1px solid black",
                padding: "1%",
                // marginTop: "-1%",
              }}
            >
              <h2 style={{ fontFamily: "Times New Roman, Times, serif" }}>
                Measurements:-
              </h2>

              <table
                className="table-style"
                style={{
                  marginBottom: "1%",
                  width: "100%",
                  border: "none",
                  borderCollapse: "collapse",
                }}
              >
                <tbody>
                  {rowData?.order_measurement
                    ?.filter(
                      (item) =>
                        item?.item_master_item_name ===
                        (rowData?.order_sub_item_name ||
                          rowData?.order_sub_item_name)
                    )
                    ?.map((measurement, index) => (
                      <React.Fragment key={index}>
                        <tr>
                          <td
                            colSpan={
                              Object.keys(measurement?.item_master_measurement)
                                .length
                            }
                          >
                            <h5
                              style={{
                                fontFamily: "Times New Roman, Times, serif",
                                fontWeight: "bold",
                                color: "black",
                                fontSize: "18px",
                                margin: "10px 0"
                              }}
                            >
                              <strong>
                                {measurement?.item_master_item_name}:-
                              </strong>
                            </h5>
                          </td>
                        </tr>
                        <tr
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "10px",
                          }}
                        >
                          {Object.entries(
                            measurement?.item_master_measurement
                          ).map(([key, value], idx) => (
                            <td
                              key={idx}
                              style={{
                                border: "0.1vw solid #ccc",
                                color: "#000000",
                                fontSize: "15px",
                                padding: "0.5% 1%",
                                textAlign: "left",
                              }}
                            >
                              <div>
                                <strong>{key}</strong>
                              </div>
                              <div style={{ textAlign: "center", marginTop: "3px" }}>{value}</div>
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </section>
          <section>
            <div style={{ borderTop: "1px solid black", padding: "1%" }}>
              <h2 style={{ fontFamily: "Times New Roman, Times, serif" }}>
                Item Details:-
              </h2>
              <div style={{overflowX:"scroll"}}>
                <table className="table-style" style={{ marginBottom: "1%" }}>
                  <thead>
                    <tr className="tr-style">
                      <td className="td-style" style={{ color: "white",minWidth:"130px" }}>
                        Order No
                      </td>
                      <td className="td-style" style={{ color: "white",minWidth:"130px" }}>
                        Item No
                      </td>
                      <td className="td-style" style={{ color: "white",minWidth:"130px" }}>
                        Item Name
                      </td>
                      <td className="td-style" style={{ color: "white",minWidth:"130px" }}>
                        Sub Item Name
                      </td>
                      <td className="td-style" style={{ color: "white",minWidth:"130px" }}>
                        Job Work Id
                      </td>
                      <td className="td-style" style={{ color: "white",minWidth:"130px" }}>
                        Fabric Code
                      </td>
                      <td className="td-style" style={{ color: "white",minWidth:"130px" }}>
                        Fabric Required
                      </td>
                      <td className="td-style" style={{ color: "white",minWidth:"130px" }}>
                        Item Remarks
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="td-boeder">{rowData?.order_no}</td>
                      <td className="td-boeder">{rowData?.order_item_no}</td>
                      <td className="td-boeder">{rowData?.order_item_name}</td>
                      <td className="td-boeder">
                        {rowData?.order_sub_item_name}
                      </td>
                      <td className="td-boeder">
                        {rowData?.order_item_job_work_id || "-"}
                      </td>
                      <td className="td-boeder">
                        {rowData?.order_item_kc_fabric_code}
                      </td>
                      <td className="td-boeder">
                        {rowData?.order_item_fabric_required}
                      </td>
                      <td
                        className="td-boeder"
                        style={{ whiteSpace: "pre-wrap", width: "400px" }}
                      >
                        {rowData?.order_item_remarks}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
          {rowData?.addons_items?.length > 0 && (
            <section>
              <div style={{ borderTop: "1px solid black", padding: "1%" }}>
                <h2 style={{ fontFamily: "Times New Roman, Times, serif" }}>
                  AddOns Details:-
                </h2>
                <table className="table-style" style={{ marginBottom: "1%" }}>
                  <thead>
                    <tr className="tr-style">
                      <td className="td-style" style={{ color: "white" }}>
                        Item Name
                      </td>
                      <td className="td-style" style={{ color: "white" }}>
                        Size
                      </td>
                      <td className="td-style" style={{ color: "white" }}>
                        Quantity
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {rowData?.addons_items &&
                      rowData?.addons_items?.map((addon, index) => (
                        <tr key={index}>
                          <td className="td-boeder">{addon?.itemName}</td>
                          <td
                            className="td-boeder"
                            style={{ textAlign: "center" }}
                          >
                            {addon?.size
                              ? addon?.size
                              : addon?.addons_size
                                ? addon?.addons_size
                                : "-"}
                          </td>
                          <td className="td-boeder">
                            {addon?.quantity
                              ? addon?.quantity
                              : addon?.addons_quantity}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </section>
          )}
          {rowData?.order_remarks && (
            <section className="page-break-remark">
              <div style={{ padding: "1%" }}>
                <h2 style={{ fontFamily: "Times New Roman, Times, serif" }}>
                  Remarks:-
                </h2>
                <span
                  style={{
                    fontFamily: "Times New Roman, Times, serif",
                    fontSize: "18px",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {rowData?.order_remarks}
                </span>
              </div>
            </section>
          )}
          {(rowData?.order_item_catalogue_image || rowData?.order_item_image) && (
            <>
              <h2
                style={{
                  fontFamily: "Times New Roman, Times, serif",
                  paddingLeft: "5px",
                }}
              >
                Images:-
              </h2>
              <div className="image-container">
                {rowData?.order_item_image &&
                  rowData?.order_item_image.map((image, index) => (
                    <div key={index}>
                      <img
                        src={`${process.env.REACT_APP_URL}/public/${image}`}
                        alt="item_image"
                      />
                    </div>
                  ))}
                {rowData?.order_item_catalogue_image &&
                  rowData?.order_item_catalogue_image.map((image, index) => (
                    <div key={index}>
                      <img
                        src={`${process.env.REACT_APP_URL}/${image}`}
                        alt="catalogue_image"
                      />
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewModal;
